// Helper untuk normalisasi URL avatar dari backend.
// Backend mengembalikan path relatif (mis. /media/avatars/x.jpg),
// sedangkan file media hanya disajikan dari origin API (api.hobibaca.com).
export function resolveAvatarUrl(url) {
  if (!url) return '';
  // Sudah URL absolut atau data URI — pakai apa adanya
  if (url.startsWith('http://') || url.startsWith('https://') || url.startsWith('data:')) {
    return url;
  }
  const base = (process.env.VUE_APP_API_BASE_URL || '').replace(/\/$/, '');
  const path = url.startsWith('/') ? url.substring(1) : url;
  return `${base}/${path}`;
}
